import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Content from 'components/Content';
import { Button, Grid, Paper, Card, CardContent, CardActions } from '@material-ui/core/';
import { sendGetRequest } from '../utils/api';
import BasicDropDown from '../components/forms/formElements/BasicDropDown';
import _ from 'lodash';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid';
import XlsxPopulate from 'xlsx-populate'

import { ContactsOutlined } from '@material-ui/icons';


const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#d0eff2", "#81948c", "#dee3a6"];

const stats = ['OPERATIONAL','RETIRED','DEFECTIVE','DISPOSED','TRANSFERRED','REPAIRED','BID'];

const columns = [
    {
        field: 'docNo',
        headerName: 'FAMAS Doc No',
        minWidth: 225,
        editable: false,
    },
    {
        field: 'approvalStatus',
        headerName: 'Status',
        minWidth: 175,
        editable: false,
    },
    {
        field: 'initApprv',
        headerName: 'Approver',
        minWidth: 175,
        editable: false,
    },
    {
        field: 'toUserName',
        headerName: 'Assignee',
        minWidth: 200,
        editable: false,
    },
    {
        field: 'toUserName',
        headerName: 'Assignee',
        minWidth: 200,
        editable: false,
    },
    {
        field: 'id',
        headerName: 'ID',
        minWidth: 100,
        editable: false,
    }

];

const useStyles = makeStyles({
root: {
    minWidth: 275,
},
bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
},
title: {
    fontSize: 14,
},
pos: {
    marginBottom: 12,
},
});
   
export default function Approval(props) {
    const classes = useStyles();

	const [rows, setRows] = useState([]);

    const [mainData, setMainData] = useState([]);
    const [businessUnits, setBusinessUnits] = useState([]);
    const [filter, setFilter] = useState({businessUnit: 'Hedcor Group', assetStat: ' ', month: ' ', year: ' '});
    const [totalItems, setTotalItems] = useState({});
    const [totalCosts, setTotalCosts] = useState({});
    const [totalOperational, setTotalOperational] = useState({});
    const [totalOthers, setTotalOthers] = useState({});

    const [itemCountPerBusinessUnit, setItemCountPerBusinessUnit] = useState([]);
    
    const [itemCountPerMonth, setItemCountPerMonth] = useState([]);

    const [itemsPerStatus, setItemsPerStatus] = useState([]);

    const [itemStatusList, setItemStatusList] = useState([]);

    const [itemYearList, setItemYearList] = useState([]);

    const [itemMonthList, setItemMonthList] = useState([
        {id: 1, value: '1', displayText: 'January'},
        {id: 2, value: '2', displayText: 'February'},
        {id: 3, value: '3', displayText: 'March'},
        {id: 4, value: '4', displayText: 'April'},
        {id: 5, value: '5', displayText: 'May'},
        {id: 6, value: '6', displayText: 'June'},
        {id: 7, value: '7', displayText: 'July'},
        {id: 8, value: '8', displayText: 'August'},
        {id: 9, value: '9', displayText: 'September'},
        {id: 10, value: '10', displayText: 'October'},
        {id: 11, value: '11', displayText: 'November'},
        {id: 12, value: '12', displayText: 'December'},
        {id: 13, value: '13', displayText: 'All'},
        ]);

    useEffect(() => {
    
        if(localStorage.getItem('businessUnits')){
            const items = JSON.parse(localStorage.getItem('businessUnits'));
            items.push({id: 'HEDCOR GROUP', value: 'HEDCOR GROUP'})
            setBusinessUnits(items);
            
            console.log(items);
        }

    }, []);

    
    const generateListYear = () => {
        const items = [];
        const d = new Date();
        let y = d.getFullYear();
        y = y - 3;
        for(let year = y; year<=y+3; year++){

            items.push({id: year, value: year});

        }
        return items;
    }


    useEffect(() => {

        if(!_.isEmpty(businessUnits)){

            const tempYears = generateListYear();
            setItemYearList(tempYears);

            const tempItemsStatusList = [];
            for(let i = 0; i < stats.length; i++){    
                tempItemsStatusList.push({id: stats[i], value: stats[i]});
            }
            tempItemsStatusList.push({id: 'All', value: 'All'});
            setItemStatusList(tempItemsStatusList);


            console.log("PREPPING DATA");
            let assetStats;

            if(localStorage.getItem('AssetStat')){
                assetStats = JSON.parse(localStorage.getItem('AssetStat')); 
            }

            //PER ASSET STAT DATA
            const tempItemsStat = [];
            for(let i = 0; i < stats.length; i++){

                const tempItem = mainData.filter((asset) => asset.assetStat === stats[i]);
                const tempCost = tempItem.reduce((a, b) => a + b.acqCost, 0);

                tempItemsStat.push({
                    "Status": stats[i],
                    "Total Cost": tempCost,
                    "Total Items": tempItem.length
                });

            }
            console.log("STAT ITEMS", tempItemsStat)
            setItemsPerStatus(tempItemsStat);
        }

    }, [businessUnits]);

	const filterData = () =>{
        let params = "";
        
        params = `?business_unit=${filter.businessUnit}`

        if(filter.assetStat && filter.assetStat.length > 1)
        params += `&asset_stat=${filter.assetStat}`;

        if(filter.year && filter.year > 1)
        params += `&year=${filter.year}`;

        if(filter.month && filter.month > 1)
        params += `&month=${filter.month}`;

        const getDataFromServer = async () =>{

            const res = await sendGetRequest(`/famas/header/forapproval${params}`);
            if(res){
                setRows(res.data);
                console.log(res.data);
            }
        }
        getDataFromServer();

    }

    const handleChange = (e) =>{
        
        setFilter({...filter, [e.target.name]: e.target.value});

    }

    function exportData() {
        XlsxPopulate.fromBlankAsync()
            .then(async function (workbook) {
              
                workbook.sheet(0).cell("A1").value([
                    [
                        'Business Unit', 'Department', 'Location', 'Asset Tag', 'Asset Description',
                        'Asset Status', 'Acquisition Cost'
                    ]
                ])
                for (var i = 0; i < rows.length; i++) {
                    const row = [
                        rows[i].businessUnit,
                        rows[i].deptName,
                        rows[i].location,
                        rows[i].assetTag,
                        rows[i].assetDesc,
                        rows[i].assetStat,
                        rows[i].acqCost
                    ]
                    workbook.sheet(0).cell("A" + (i + 2)).value([row])
                }
                
                workbook.outputAsync()
                    .then(function (blob) {
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            // If IE, you must uses a different method.
                            window.navigator.msSaveOrOpenBlob(blob, "FAMAS_Records_MasterList.xlsx");
                        } else {
                            var url = window.URL.createObjectURL(blob);
                            var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.href = url;
                            a.download = "FAMAS_Records_MasterList.xlsx";
                            a.click();
                            window.URL.revokeObjectURL(url);
                            document.body.removeChild(a);
                        }
                    });
            })
    }

	return (
		<Content>
			<Typography component="h2" variant="h6" color="primary" gutterBottom>
			    For Approval Report 
		    </Typography>
            <Grid 
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                spacing = {3}
            >
                <Grid item xs={12} md={3}>
                    <BasicDropDown 
						name="businessUnit"
						label="Business Unit"
						value={filter.businessUnit || ' '}
						onChange={(e)=>handleChange(e)}
						options={businessUnits}
						
					/>
                </Grid>
                <Grid item xs={12} md={3}>
                    <BasicDropDown 
						name="assetStat"
						label="Status"
						value={filter.assetStat || ' '}
						onChange={(e)=>handleChange(e)}
						options={itemStatusList}
						
					/>
                </Grid>
                <Grid item xs={12} md={3}>
                    <BasicDropDown 
						name="year"
						label="Year"
						value={filter.year || ' '}
						onChange={(e)=>handleChange(e)}
						options={itemYearList}
						
					/>
                </Grid>
                <Grid item xs={12} md={3}>
                    <BasicDropDown 
						name="month"
						label="Month"
						value={filter.month || ' '}
						onChange={(e)=>handleChange(e)}
						options={itemMonthList}
						
					/>
                </Grid>
                <Grid item xs={12} md={12} style={{justifyContent: 'center'}}>
                    <Typography align='center'>
                        <Button
                            type="submit"
                            onClick={(e)=>{filterData(e)}}
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<DynamicFeedIcon />}
                        >
                                    Filter
                        </Button>
                    </Typography>
                    
                   
                </Grid>
            </Grid>
            <hr/>
            <Grid 
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                spacing = {3}
            >
                <Grid item xs={12} md={12}>

                    <div style={{ height: 600, width: '100%' }}>
                        <DataGrid
                            rows={rows}
                            rowHeight={100} 
                            columns={columns}
                            pageSize={50}
                            rowsPerPageOptions = {[50, 75, 100]} 
                            
                            disableSelectionOnClick
                            
                        />
                    </div>

                </Grid>
                <Grid item xs={12} md={12}>

                    <Typography align='center'>
                        <Button
                            type="submit"
                            onClick={(e)=>{exportData(e)}}
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<DynamicFeedIcon />}
                        >
                                    Export
                        </Button>
                    </Typography>

                </Grid>
            </Grid>
            
            
              
                
            
        </Content>
	);
}
